import { PatientInfo } from 'core/models/jianDetail/patientInfo';

type Props = {
  /* 傷病者名のリスト。 */
  patientNameList: {
    /* 傷病者ID。 */
    patientId: PatientInfo['patientId'];
    /* 傷病者名。 */
    patientName: PatientInfo['baseInfo']['patientName'];
  }[];
  /** 傷病者を選択する関数。 */
  selectPatient: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  /* 選択中の傷病者ID。 */
  selectedPatientId: PatientInfo['patientId'];
};

/** 傷病者を選択するコンポーネント。 */
export const Select = ({
  patientNameList,
  selectPatient: handleChange,
  selectedPatientId,
}: Props) => {
  return (
    <div className="relative w-[200px]">
      <select
        className="block w-full appearance-none bg-white border border-textPrimary rounded-md py-[12px] pl-[16px] pr-[40px] text-16px text-textPrimary focus:outline-none overflow-hidden whitespace-nowrap overflow-ellipsis"
        onChange={handleChange}
        value={selectedPatientId}
      >
        {patientNameList.map((patient, index) => (
          <option key={index} value={patient.patientId}>
            {patient.patientName ||
              `不明${countUnknownPatients({ patientNameList, index })}`}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
        <ChevronDownIcon />
      </div>
    </div>
  );
};

type CountUnknownPatientsProps = {
  /** 傷病者名のリスト。 */
  patientNameList: Props['patientNameList'];
  /** インデックス番号。 */
  index: number;
};

/** 不明の傷病者名をカウントする関数。 */
const countUnknownPatients = ({
  patientNameList,
  index,
}: CountUnknownPatientsProps) => {
  /** 表示用インデックスのオフセット。 */
  const displayIndexOffset = 1;

  return patientNameList
    .slice(0, index + displayIndexOffset)
    .filter(p => !p.patientName).length;
};

const ChevronDownIcon = () => {
  return (
    <svg
      className="text-primary size-7"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};
